import { Input, Select, TextArea } from "@aidkitorg/component-library";
import React from "react";
import { useLocalizedStrings } from "../../../Localization";
import { useAggregationOptions } from "../hooks/useAggregationOptions";
import { useFieldOptions } from "../../hooks/useFieldOptions";

export type PieChartFormFieldsProps = {
  title: string,
  setTitle: (val: string) => void,

  description: string,
  setDescription: (val: string) => void,

  groupDataField: string,
  setGroupDataField: (val: string) => void,
 
  aggregation: string,
  setAggregation: (val: string) => void,

  dataField: string,
  setDataField: (val: string) => void
}

export const PieChartFormFields: React.FC<PieChartFormFieldsProps> = ({
  title, setTitle,
  description, setDescription,
  groupDataField, setGroupDataField,
  aggregation, setAggregation,
  dataField, setDataField
}) => {
  const L = useLocalizedStrings()
  const {aggregationOptions, getAggregationOption} = useAggregationOptions()
  const { fieldOptions, getSelectedFieldOption } = useFieldOptions()

  return <>
    <Input 
      required
      label={L.admin_panel.dashboards.chart_title}
      value={title}
      onChange={(e) => setTitle(e.target.value)}
    />

    <Select
      portal
      required
      virtualized
      options={fieldOptions}
      label={L.admin_panel.dashboards.group_by}
      description={L.admin_panel.dashboards.group_by_description}
      labelLocation="above"
      value={getSelectedFieldOption(groupDataField)}
      onChange={(value) => {
        if (value) setGroupDataField(value.value)
      }}
      placeholder={L.admin_panel.dashboards.x_axis_placeholder}
      searchable
    />
    
    <div className="space-y-1">
      <label className="block text-sm font-medium text-gray-700">
        {L.admin_panel.dashboards.chart_values}
      </label>
      <div className="text-sm text-gray-600 bg-gray-50 p-3 rounded-md border">
        📊 <strong>{L.admin_panel.dashboards.applicant_count}</strong> - {L.admin_panel.dashboards.applicant_count_pie_chart_desc}
      </div>
    </div>
    
    <TextArea
      label={L.admin_panel.dashboards.description}
      showLabel
      value={description}
      onChange={(e) => setDescription(e.target.value)}
    />
  </>
}